import React from "react";
import { useHistory } from "react-router-dom";
import { Link } from "@material-ui/core";
import DataTable from "@/components/DataTable";
import { SimpleStatusChip } from "@/components/commons/StatusChip";
import { getAlarmTemplateDevicesApi } from "@/apis/apiCollection";
import { ReactRender } from "@/components/ReactRender";
import { useTranslation } from "@/langs/useTranslation";

export const AlarmViewDevicesListDatatable = React.forwardRef(
  ({ className, style, templateId, children, onLoaded }, ref) => {
    const { t } = useTranslation();
    const history = useHistory();

    const columns = [
      {
        data: "serial_number",
        title: t({ defaultMessage: "设备SN" }),
        searchable: true,
        createdCell: (td, data, row) => {
          ReactRender(
            <Link
              color="primary"
              onClick={() => {
                history.push(
                  `/device-list/device-detail/${row.id}/${row.os_type}`
                );
              }}
            >
              {data}
            </Link>,
            td
          );
        }
      },
      {
        data: "device_name",
        title: t({ defaultMessage: "设备名称" })
      },
      {
        data: "detail",
        title: t({ defaultMessage: "描述" })
      },
      {
        data: "online_offline_status",
        title: t({ defaultMessage: "设备状态" }),
        searchable: true,
        createdCell: (td, data) => {
          ReactRender(
            <SimpleStatusChip
              key={data}
              size="small"
              color={data === "online" ? "primary" : "default"}
              statusLabel={data}
            />,
            td
          );
        }
      },
      {
        data: "groups",
        title: `${t({ defaultMessage: "门店" })}`,
        orderable: true,
        searchable: true,
        render: data => {
          return data?.map(item => item.name).join(", ");
        }
      },
      {
        data: "tags",
        title: t({ defaultMessage: "标签" }),
        searchable: true,
        render: data => {
          return data?.map(item => item.name).join(", ");
        }
      }
      // {
      //   data: "triggered_status",
      //   title: t({ defaultMessage: "触发状态" }),
      //   searchable: true,
      //   createdCell: (td, data) => {
      //     ReactRender(
      //       <ChipStatus
      //         type={data === 1 ? "info" : "warn"}
      //         label={
      //           data === 1
      //             ? t({ defaultMessage: "已触发" })
      //             : t({ defaultMessage: "未触发" })
      //         }
      //       />,
      //       td
      //     );
      //   }
      // }
    ];

    const ajax = (data, callback, settings) => {
      return getAlarmTemplateDevicesApi({
        alarm_template_id: templateId,
        page: data.page,
        pageSize: data.pageSize
      }).then(res => {
        callback({
          data: res.data,
          draw: data.draw,
          recordsFiltered: res.recordsTotal,
          recordsTotal: res.recordsTotal
        });
      });
    };

    return (
      <DataTable
        ref={ref}
        columns={columns}
        ajax={ajax}
        className={className}
        style={style}
        autoLoad
        showCheckAll={false}
        onLoaded={onLoaded}
      >
        {children}
      </DataTable>
    );
  }
);
